import { AlertTriangle } from 'lucide-react'

import { EmptyState } from '@/components/feedback/EmptyState'
import { Button } from '@/components/ui/button'
import { messages } from '@/lib/messages'
import { toProblem } from '@/lib/problem'

interface ErrorStateProps {
  error: unknown
  onRetry?: () => void
}

/**
 * Veri yüzeylerinin dört zorunlu durumundan biri (AGENTS.md §10).
 * `error`'dan çözülen `problem+json` gövdesinin `title`/`detail` alanları gösterilir.
 */
export function ErrorState({ error, onRetry }: ErrorStateProps) {
  const problem = toProblem(error)
  return (
    <EmptyState
      title={problem.title || messages.states.errorTitle}
      description={problem.detail || messages.states.errorHint}
      icon={<AlertTriangle className="text-danger size-6" strokeWidth={1.5} />}
      action={
        onRetry && (
          <Button variant="outline" size="sm" onClick={onRetry}>
            {messages.common.retry}
          </Button>
        )
      }
    />
  )
}
